import moment from 'moment';
import { GET_PRESS_RELEASE } from '../constants/actionTypes';
import { getPressRelease } from '../utils/apiPressRelease';

export const showPressReleases = dispatch =>
  new Promise((resolved, reject) => {
    getPressRelease()
      .then(response => {
        response.map((item, index) => {
          const pressDate = `${moment(item.creationDate).format('DD/MM')}`;
          response[index].creationDate = pressDate;
          return undefined;
        });

        dispatch({
          type: GET_PRESS_RELEASE,
          payload: response
        });
        resolved(response);
      })
      .catch(error => {
        reject();
        throw error;
      });
  });
